module.exports = __webpack_public_path__ + "img/3.26f5b65f.png";